import React from 'react';
import Box, { BoxProps } from '@mui/material/Box';

interface TabPanelProps extends BoxProps {
    children: React.ReactNode;
    index: number;
    value: number;
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index, ...rest }) => (
    <Box hidden={value !== index}>{value === index && <Box {...rest}>{children}</Box>}</Box>
);

export default TabPanel;
